import { render, staticRenderFns } from "./LbaExtraSetting.vue?vue&type=template&id=55e3f03e"
import script from "./LbaExtraSetting.vue?vue&type=script&lang=js"
export * from "./LbaExtraSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports